<template>
  <div class="register absolute auth-register">
    <van-nav-bar
      :title="$t('m.dl_span7')"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <div class="shading" style="padding:0 40px;">
      <div
        class="pictrue acea-row row-center-wrapper"
        style="height: 0.8rem;"
      ></div>
      <div class="biaoti">
        <div style="display:flex;align-items:center;">
          <img
            src="../../assets/images/asmpt_logo.svg"
            style="border-radius:0;"
            alt="ASM Pacific"
          />
        </div>
        {{ $t("m.dl_span03") }}！
      </div>
    </div>
    <div class="register_block">
      <div class="register_block_list email-row">
        <input
          class="email-input"
          type="text"
          v-model.trim="emailName"
          autocomplete="username"
          placeholder="请输入邮箱"
        />
        <select
          class="email-suffix-select"
          v-model="emailSuffix"
          aria-label="邮箱后缀"
        >
          <option
            v-for="suffix in emailSuffixes"
            :key="suffix"
            :value="suffix"
          >
            {{ suffix }}
          </option>
        </select>
      </div>
      <div class="register_code">
        <div class="register_code_list" style="flex:1;">
          <input
            style="width:140px;"
            v-model="codeVal"
            placeholder="邮箱验证码"
          />
        </div>
        <div class="register_code_lists">
          <p class="" @click="code">{{ codeBtnTit }}</p>
        </div>
      </div>
      <div class="register_block_list">
        <input
          v-model="password"
          type="password"
          autocomplete="new-password"
          placeholder="登录密码（大写字母+小写字母+数字）"
        />
      </div>
      <p class="password-rule">至少6位，必须同时包含大写字母、小写字母和数字</p>
      <div class="register_block_list">
        <input
          v-model="payPassword"
          type="password"
          :placeholder="$t('m.dl_span25')"
        />
      </div>
      <div class="register_block_list">
        <input
          v-model.trim="invite"
          type="text"
          autocomplete="off"
          maxlength="8"
          placeholder="请输入邀请码（必填）"
        />
      </div>
      <van-button native-type="button" class="register_submit" @click="registerReset">{{
        $t("m.tijiao")
      }}</van-button>
      <!-- <div class="register_mgs">
        <p class="register_zq">
          <img src="../../assets/images/new/hongxuan.png" />
        </p>
        <p class="register_trip" @click="$router.push({ name: 'xuzhi' })">
          登录/注册即代表您同意我们的使用条款和条件
        </p>
      </div> -->
    </div>
    <div
      v-if="show"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        加载中。。。
      </div>
    </div>
  </div>
</template>

<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import { registerVerify1, register, login, getCodeApi } from "@api/user";
import { validatorDefaultCatch } from "@utils/dialog";
import { required, email } from "@utils/validate";
import { VUE_APP_API_URL } from "@utils";
import cookie from "@utils/store/cookie";

const BACK_URL = "login_back_url";

const DEFAULT_EMAIL_SUFFIXES = [
  "@gmail.com",
  "@outlook.com",
  "@hotmail.com",
  "@icloud.com",
  "@yahoo.com",
  "@proton.me",
  "@aol.com",
  "@live.com",
  "@msn.com",
  "@mail.com",
  "@qq.com",
  "@foxmail.com",
  "@163.com",
  "@126.com",
  "@sina.com",
  "@yeah.net",
  "@naver.com",
  "@daum.net",
  "@yandex.com"
];

export default {
  name: "Register",
  data: function() {
    return {
      value: 86,
      show: false,
      disabled: false,
      alltime: 60,
      codeBtnTit: this.$t("m.dl_span9"),
      account: "",
      emailName: "",
      emailSuffix: "@gmail.com",
      emailSuffixes: DEFAULT_EMAIL_SUFFIXES.slice(),
      password: "",
      payPassword: "",
      captcha: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      invite: "",
      isShowCode: false
    };
  },
  mixins: [sendVerifyCode],
  mounted: function() {
    this.codeBtnTit = this.$t("m.dl_span9");
    this.invite = String(this.$route.query.spread || "").trim();
  },
  methods: {
    sendCode() {
      //倒计时
      let alltime = this.alltime;
      if (alltime == 0) {
        this.alltime = 60;
        this.codeBtnTit = this.$t("m.dl_span9");
        this.disabled = false;
        return;
      } else {
        alltime--;
        this.codeBtnTit = this.$t("m.dl_span13") + alltime;
        this.alltime = alltime;
        this.disabled = true;
      }
      let that = this;
      setTimeout(function() {
        that.sendCode();
      }, 1000);
    },
    again() {
      this.codeUrl =
        VUE_APP_API_URL + "/captcha?" + this.keyCode + Date.parse(new Date());
      console.log(this.codeUrl);
    },
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.response.data.msg);
        });
    },
    getEmailAccount() {
      const account = String(this.emailName || "").trim();
      if (!account) {
        return "";
      }
      if (account.indexOf("@") > -1) {
        return account.toLowerCase();
      }
      return `${account}${this.emailSuffix}`.toLowerCase();
    },
    async registerReset() {
      const account = this.getEmailAccount();
      this.account = account;
      const { password, payPassword, codeVal, invite } = this;
      try {
        await this
          .$validator({
            account: [
              required(required.message("邮箱")),
              email(email.message())
            ],
            codeVal: [required(required.message("验证码"))],
            password: [required(required.message("密码"))],
            payPassword: [required(required.message("支付密码"))],
            invite: [required(required.message("邀请码"))],
            captcha: this.isShowCode ? [required(required.message("密码"))] : []
          })
          .validate({ account, password, payPassword, codeVal, invite });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)\S{6,255}$/.test(password)) {
        return this.$dialog.error("登录密码必须同时包含大写字母、小写字母和数字，且不少于6位");
      }
      this.show = true;
      let registrationCompleted = false;
      try {
        await register({
          email: account,
          password: this.password,
          paypwd: this.payPassword,
          sms: this.codeVal,
          invite: this.invite
        });
        registrationCompleted = true;

        const loginResponse = await login({
          area: 0,
          username: account,
          password: this.password,
          system: "android"
        });
        const loginData =
          loginResponse && loginResponse.data && loginResponse.data.data;
        if (!loginData || !loginData.access_token) {
          throw new Error("自动登录未返回有效凭证");
        }

        const expiresSeconds = Number(loginData.expires) || 86400;
        const loginState = {
          token: loginData.access_token,
          expires_time: new Date().getTime() + expiresSeconds * 1000,
          kf: loginData.kf || "",
          view: loginData.view || false
        };
        window.localStorage.setItem("zhanghao", account);
        window.localStorage.setItem("quhao", "0");
        window.localStorage.setItem("mima", this.password);
        this.$store.commit("LOGIN", loginState);
        cookie.remove(BACK_URL);
        this.show = false;
        await this.$dialog.success("注册成功，正在进入平台", { timeout: 1200 });
        this.$router.replace({ path: "/user" });
      } catch (error) {
        this.show = false;
        const responseMessage =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.msg;
        const message = registrationCompleted
          ? "注册成功，但自动登录失败，请稍后直接使用新账号登录"
          : responseMessage || error.message || "注册失败，请稍后重试";
        this.$dialog.error(message);
      }
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    async code() {
      var that = this;
      const account = that.getEmailAccount();
      that.account = account;
      try {
        await that
          .$validator({
            account: [
              required(required.message("邮箱")),
              email(email.message())
            ]
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (this.disabled == true) {
        return;
      }
      registerVerify1({
        email: account
      })
        .then(res => {
          that.sendCode();
          that.$dialog.alert({
            mes:
              "<strong>验证码已发送</strong><br><br>如果您没有及时收到您的注册验证码，请留意是否被您的邮箱归类到垃圾邮件里去了！"
          });
        })
        .catch(res => {
          // if (res.data.status === 402) {
          //   that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
          //   that.isShowCode = true;
          // }
          const message =
            res && res.response && res.response.data && res.response.data.msg;
          this.$dialog.error(message || "验证码发送失败，请稍后重试");
        });
    }
  }
};
</script>
<style scoped lang="less">
.biaoti {
  /* text-align: center; */
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 210px;
    height: auto;
  }
}
.register_zq {
  width: 15px;
  height: 15px;
}
.register_zq img {
  border-radius: 6px;
  width: 100%;
  height: 100%;
  display: block;
}
.register_mgs {
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 12px;

  /* padding: 15px 0px; */
  // justify-content: center;
}
.register_trip {
  font-size: 12px;
  color: #666;
  margin-left: 4px;
}
.register_submit {
  width: 100%;
  margin: 0 auto;
  height: 45px;
  background: var(--bg-color);
  border-radius: 30px;
  margin-top: 40px;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  border: 0px solid;
  font-size: 15px;
  font-weight: bold;
}
.register_block {
  padding: 0 40px;
  margin-top: 20px;
}
.register_block_list {
  width: 100%;
  height: 50px;
  padding: 0 0px;
  /* background: #f1f1f3; */
  /* border-radius: 5px; */
  display: flex;
  align-items: center;
  font-size: 14px;

  border-bottom: 1px solid #eee;
}
.register_block_list input {
  line-height: 50px;
  height: 50px;
  width: 100%;
  font-size: 15px;
}
.password-rule {
  margin-top: 8px;
  color: #8b96a5;
  font-size: 11px;
  line-height: 18px;
}
.email-row {
  min-height: 56px;
  height: auto;
  gap: 8px;
  padding: 4px 0;
  box-sizing: border-box;
}
.email-row .email-input {
  flex: 1;
  min-width: 0;
  height: 42px;
  line-height: 42px;
}
.email-suffix-select {
  flex: 0 0 auto;
  max-width: 132px;
  height: 36px;
  line-height: 36px;
  margin-top: 2px;
  padding: 0 10px;
  border: 1px solid #eeeeee;
  border-radius: 18px;
  background: #f7f8fa;
  color: #333333;
  font-size: 13px;
  outline: none;
  box-sizing: border-box;
}
.register_code_lists {
  background: var(--bg-color);
  color: #ffffff;
  border-radius: 20px;
  height: 32px;
  margin-left: 0px;
  padding: 0 15px;
  line-height: 32px;
  font-weight: bold;
  font-size: 13px;
}
.register_code_list {
  width: 100%;
  height: 50px;

  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.register_code_list input {
  line-height: 50px;
  height: 50px;
  width: 100%;
  font-size: 15px;
}
.register_code {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
}
.register_tit {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
/deep/ .van-nav-bar .van-icon {
  color: #333;
}
/deep/ .flag-list-box {
  background: #fff;
}
/deep/ .flag.flag-cf {
  display: none;
}
/deep/ .flag {
  display: none;
}
/deep/ .country-name {
  display: none;
}
/deep/ .area-codeNum {
  display: none !important;
}
/deep/ .intl-tel-input-container {
  padding-left: 3px !important;
  border-right: 1px solid #eee !important;
}

/* Premium registration refresh — navy, brand red and neutral surfaces only. */
.auth-register {
  box-sizing: border-box;
  min-height: 100vh;
  height: auto;
  padding-bottom: 35px;
  overflow-x: hidden;
  color: #eaf2fb;
  background:
    radial-gradient(circle at 88% 6%, rgba(47, 139, 204, 0.2), transparent 28%),
    linear-gradient(155deg, #061a31 0%, #0a3158 58%, #0b2744 100%) !important;
}

.auth-register::before {
  position: absolute;
  inset: 0;
  content: "";
  pointer-events: none;
  opacity: 0.17;
  background-image:
    linear-gradient(rgba(121, 178, 224, 0.09) 1px, transparent 1px),
    linear-gradient(90deg, rgba(121, 178, 224, 0.09) 1px, transparent 1px);
  background-size: 38px 38px;
}

.auth-register /deep/ .van-nav-bar {
  position: relative;
  z-index: 2;
  color: #edf5fb;
  background: transparent;
  box-shadow: none;
}

.auth-register /deep/ .van-nav-bar__title,
.auth-register /deep/ .van-nav-bar .van-icon {
  color: #e8f1f8;
}

.auth-register .shading {
  position: relative;
  z-index: 1;
  width: auto;
  padding: 25px 32px 26px !important;
  background: none;
}

.auth-register .shading::before {
  display: block;
  margin-bottom: 14px;
  color: #a6c6df;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 1.7px;
  content: "ASM PACIFIC · GLOBAL WEALTH";
}

.auth-register .shading .pictrue {
  display: none;
}

.auth-register .biaoti {
  align-items: flex-start;
  color: #fff;
  font-size: 23px;
  font-weight: 650;
  line-height: 1.45;
}

.auth-register .biaoti::after {
  display: block;
  margin-top: 7px;
  color: rgba(218, 234, 247, 0.64);
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.3px;
  content: "一个账户，连接研究、产品与专属服务";
}

.auth-register .biaoti img {
  width: 160px;
  margin-bottom: 19px;
  padding: 8px 10px;
  background: rgba(255, 255, 255, 0.94);
  border-radius: 8px !important;
}

.auth-register .register_block {
  position: relative;
  z-index: 2;
  margin: 0 18px;
  padding: 24px 19px 20px;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.76);
  border-radius: 20px;
  box-shadow: 0 24px 55px rgba(0, 12, 29, 0.31);
}

.auth-register .register_block::before {
  display: block;
  margin-bottom: 8px;
  color: #a9332c;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 1.5px;
  content: "CREATE ACCOUNT";
}

.auth-register .register_block::after {
  display: block;
  margin-top: 14px;
  color: #8b97a5;
  font-size: 8px;
  line-height: 1.55;
  text-align: center;
  content: "注册即表示您同意用户服务与隐私条款";
}

.auth-register .register_block_list,
.auth-register .register_code {
  box-sizing: border-box;
  min-height: 49px;
  height: auto;
  margin-top: 12px;
  padding: 0 11px;
  background: #f4f7fa;
  border: 1px solid #e3eaf1;
  border-radius: 11px;
}

.auth-register .register_block_list:focus-within,
.auth-register .register_code:focus-within {
  background: #fff;
  border-color: #6da9d5;
  box-shadow: 0 0 0 3px rgba(37, 135, 206, 0.1);
}

.auth-register .register_block_list input,
.auth-register .register_code_list input {
  height: 46px;
  color: #172b43;
  font-size: 12px;
  line-height: 46px;
  background: transparent;
}

.auth-register .email-suffix-select {
  max-width: 112px;
  height: 32px;
  padding: 0 0 0 7px;
  color: #425a72;
  font-size: 10px;
  background: transparent;
  border: 0;
  border-left: 1px solid #dbe4ed;
  border-radius: 0;
}

.auth-register .register_code_lists {
  height: 31px;
  padding: 0 10px;
  color: #1769b0;
  font-size: 9px;
  line-height: 31px;
  background: #e7f2fb;
  border-radius: 9px;
}

.auth-register .register_submit {
  height: 47px;
  margin-top: 22px;
  color: #fff;
  font-size: 13px;
  line-height: 47px;
  background: linear-gradient(105deg, #0d3b67, #1778b9);
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(18, 90, 143, 0.22);
}

@media (min-width: 700px) {
  .auth-register {
    min-height: 100vh;
  }
}
</style>

